export default "__VITE_ASSET__cfc72392__"